import { Visibility } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
const columnShape = [
    {
        Header: 'No',
        accessor: 'number',
        maxWidth: 60,
        Cell: ({ row }) => {
            return <Box>{row.original.number || '-'}</Box>;
        },
    },
    {
        Header: 'Name',
        accessor: 'user.fullName',
        Cell: ({ row }) => {
            return (
                <Box>
                    <Box sx={{ fontWeight: 'bold' }}>
                        {row.original.user.fullName}
                    </Box>
                    <Box sx={{ color: 'text.disabled' }}>
                        {row.original.user.email}
                    </Box>
                </Box>
            );
        },
    },
    {
        Header: 'Title',
        accessor: 'title',
        minWidth: 300,
        Cell: ({ value }) => value || '-',
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row, handleDetail }) => {
            const showButtonDelete =
                localStorage.getItem('role') === 'admin' ? 'block' : 'none';
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <IconButton
                        onClick={() => handleDetail(row.original)}
                        sx={{
                            color: 'text.primary',
                            fontSize: 18,
                        }}
                    >
                        <Visibility />
                    </IconButton>
                </Box>
            );
        },
    },
];
export default columnShape;
